import BookCarousel from "../BookCarousel/BookCarousel";
import { useState, useEffect } from "react";
import BookInteractionPill from "../(book-interactions)/BookInteractionPill/BookInteractionPill";
import MobileBookCarousel from "../BookCarousel/MobileBookCarousel";
import BookPrompt from "../(book-interactions)/BookPrompt/BookPrompt";
import "../BookCarousel/some.css";
import { BookInterface } from "../books/types/book";
import { useIsClient } from "@/hooks/useBrowser";
import { fetchSavedBooksIds } from "@/app/actions/bookActions";
import styles from "./BookShelf.module.css";  

const BookShelf = ({
  books: initialBooks,
  share_id,
  query,
}: {
  books: BookInterface[],
  share_id?: string,
  query: string,
}) => {
  const [activeBook, setActiveBook] = useState<BookInterface>(initialBooks[0]);
  const [isMobile, setIsMobile] = useState(false);
  const [savedBookIds, setSavedBookIds] = useState<string[]>([]);
  const [isDetailsOpen, setIsDetailsOpen] = useState(false);
  const isClient = useIsClient();

  useEffect(() => {
    if (!isClient) return;

    async function fetchInitialData() {
      const [savedBooks] = await Promise.all([
        fetchSavedBooksIds(),
      ]);
      
      setSavedBookIds(savedBooks);
    }
    
    fetchInitialData();
  }, [isClient]);

  const isBookSaved = (workUrn: string) => {
    return savedBookIds.includes(workUrn);
  };

  const handleToggleDetails = () => {
    setIsDetailsOpen(prevState => !prevState);
  };

  useEffect(() => {
    if (!isClient) return;

    const checkMobile = () => {
      setIsMobile(window.matchMedia('(max-width: 768px)').matches);
    };
    
    checkMobile(); // Check initially
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, [isClient]);


  useEffect(() => {
    if (!isClient) return;
    const checkMobile = () => {
      const isMobileCheck = window.matchMedia('(max-width: 768px)').matches;
      setIsMobile(isMobileCheck);
    };
    checkMobile(); // Check initially
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, [isClient]);
  
;
  const [viewportDetermined, setViewportDetermined] = useState(false);

useEffect(() => {
  if (!isClient) return;
  
  const timer = setTimeout(() => {
    const isMobileCheck = window.matchMedia('(max-width: 768px)').matches;
    setIsMobile(isMobileCheck);
    setViewportDetermined(true);
  }, 10); // Very small delay
  
  return () => clearTimeout(timer);
}, [isClient]);

  return (
    <div className={styles.bookshelfContainer}>
  
      {viewportDetermined ? (
        <div className={styles.carouselSection}>
        {isMobile ? (
          <>
          <div className={styles.promptWrapper}>
            <BookPrompt query={query} searchId={share_id} />
          </div>
          <MobileBookCarousel
            books={initialBooks}
            activeBook={activeBook}
            onActiveBookChange={setActiveBook}
            isDetailsOpen={isDetailsOpen}
            onToggleDetails={handleToggleDetails}
          />
          </>
        ) : (
          <>
          <div className={styles.promptWrapper}>
            <BookPrompt query={query} searchId={share_id} />
          </div>
          <BookCarousel
            books={initialBooks}
            activeBook={activeBook}
            onActiveBookChange={setActiveBook}
            isDetailsOpen={isDetailsOpen}
            onToggleDetails={handleToggleDetails}
          />
          </>
        )}
      </div>
      ) : (<></>)}
      <>
        <BookInteractionPill
          activeBook={activeBook}
          share_id={share_id}
          isSaved={activeBook ? isBookSaved(activeBook.work_urn) : false}
          onSave={(workId) => {setSavedBookIds(prev => [...prev, workId])}}
          onUnsave={(workId) => {setSavedBookIds(prev => prev.filter(id => id !== workId))}}
          allBooks={initialBooks}
          query={query}
          isDetailsOpen={isDetailsOpen}
          onToggleDetails={handleToggleDetails}
        />
      </>
    </div>
  );
};

export default BookShelf;